<template>
  <div
    class="d-flex flex-wrap"
    style="row-gap: .4rem;"
    :class="{ 'mr-0': $vuetify.rtl, 'ml-3': !$vuetify.rtl && !isMobile && !isTablet , 'ml-1': !$vuetify.rtl && isMobile || isTablet}"
  >
    <v-hover
      v-for="(item, i) in items"
      :key="i"
      v-slot="{ hover }"
    >
      <v-container
        style="cursor: pointer;"
        class="px-2 py-1 ml-1 pin-wrapper gap-1 mx-0"
        @click="goTo(item.to)"
      >
        <div
          class="icon-wrapper"
          :style="{ 'background-color': item.color ? item.color : '#000' }"
        >
          <v-icon size="13" color="white">{{ (item.icon ? 'mdi-pin' : 'mdi-pin') }}</v-icon>
        </div>
        <v-card-text class="pa-0 text-caption">{{ item.title }}</v-card-text>
        <v-btn
          v-if="hover"
          color="pink"
          fab
          elevation="1"
          left
          :loading="loading"
          style="position: absolute;z-index: 2;width: 20px;height: 20px"
          class="pa-0"
          @click.stop.prevent="remove(item)"
        >
          <v-icon size="15">
            mdi-close
          </v-icon>
        </v-btn>
      </v-container>
      <!-- <div
        class="align-center shortcut me-3 mb-3"
        style="cursor: pointer"
        @click="goTo(item.to)"
      >
        <v-btn
          v-if="hover"
          color="pink"
          fab
          elevation="1"
          left
          :loading="loading"
          style="position: absolute;min-width: 15px !important;z-index: 2;width: 18px;height: 18px"
          class="pa-0"
          @click.stop.prevent="remove(item)"
        >
          <v-icon small>
            mdi-close
          </v-icon>
        </v-btn>
        <div class="shortcut-icon text-center">
          <v-icon
            style="margin-top: 5px"
            large
            :color="item.color"
          >
            {{ (item.icon ? 'mdi-link-box' : 'mdi-link-box') }}
          </v-icon>
        </div>
        <div class="shortcut-title mt-1">
          {{ item.title }}
        </div>
      </div> -->
    </v-hover>
  </div>
</template>

<script>
import General from '../../../../../Mixins/general'
export default {
  name: 'Shortcut',
  mixins: [General],
  data: () => ({
    items: [],
    loading: false,
    windowWidth: window.innerWidth
  }),
  watch: {
    layout () {
    },
    '$store.state.shortcutItems': {
      deep: true,
      handler (newVal) {
        this.getItems()
      }
    }
  },
  mounted  () {
    this.getItems()
  },
  methods: {
    remove (item) {
      var app = this
      if (!item) return false
      app.loading = true
      app.$axios.delete(this.$endpoint + 'shortcut/' + item.id)
        .then(res => {
          res = res.data
          app.getItems()
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    },
    getItems () {
      var app = this
      app.loading = true
      app.filter = false
      app.$axios.get(this.$endpoint + 'shortcut', {
        params: {
        }
      })
        .then(res => {
          res = res.data
          app.items = res
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => {
          app.loading = false
        })
    }
  }
}
</script>

<style scoped>
.pin-wrapper {
  background-color: #fff;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  width: fit-content;
  white-space: nowrap;
}
.pin-wrapper .icon-wrapper {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2.5px;
  background-color: red;
}
.shortcut {
  max-width: 45px;
  width: fit-content;
}
.shortcut-icon {
  background-color: #fff;
  border-radius: 4px;
  width: 45px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  height: 45px
}
.shortcut-title {
  /*font-family: Vazirmatn !important;*/
  text-align: center;
  /*text-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;*/
  /*text-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;*/
  text-shadow: rgb(0 0 0 / 49%) 0px 2px 4px;
  text-wrap: normal;
  font-size: 11px;
  color: #FFFFFF;
}
</style>
